// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LocationCitySearchPagingResultModel from '../../model/location-city-search-paging-result-model';
import LocationCitySearchPagingResultDTO from '../dto/location-city-search-paging-result-dto';
import dtoSchema from '../schemas/location-city-search-paging-result-schema';
import LocationCitySearchModel from '../../model/location-city-search-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class LocationCitySearchPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LocationCitySearchPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LocationCitySearchModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: LocationCitySearchModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<LocationCitySearchPagingResultDTO>): LocationCitySearchPagingResultModel;
  static toModel(dto: DeepPartial<LocationCitySearchPagingResultDTO> | undefined | null): LocationCitySearchPagingResultModel | undefined;
  static toModel(dto: DeepPartial<LocationCitySearchPagingResultDTO> | undefined | null): LocationCitySearchPagingResultModel | undefined {
    return dto ? new LocationCitySearchPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LocationCitySearchPagingResultModel> | LocationCitySearchPagingResultModel): LocationCitySearchPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as LocationCitySearchPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LocationCitySearchPagingResultModel, can not map to LocationCitySearchPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
